import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import React, { useCallback, useEffect, useState, useContext, useMemo } from "react";
import {
  filterAppInfo,
  filterContactInfo,
  filterGroupInfo,
  filterJoySpaceInfo,
  SearchGlobalContext,
  filterScheduleInfo,
  filterDeptsInfo,
  getStartEndTime,
  groupsSort
} from "@/components/Modals/SearchGlobalModal/utils";
import throttle from "lodash/throttle";
import isNull from "lodash/isNull";
import { LoadMore } from "@jd/focus-desktop-comps/lib/es/List";
import { List, Empty, Button } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import SearchListItem from "./ListItem";
import SearchAppItem from "./SearchAppItem";
import lodashTrim from "lodash/trim";
import { connect } from "dvajs";
import noContent from "@/assets/img/search-nodata.png";
const loadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
import {
  DeptInfo,
  SearchGlobalParams,
  SearchWorkTypes,
  SearchType
} from "@/services/SearchService";
import SearchScheduleItem from "./SearchScheduleItem";
import config, { ConfigEnum } from "@/config/config";
import styles from "@/components/styles";
import userCardIcon from "@/assets/img/user-card-icon.png";
import Loading from "@/components/Loading";
import { getContactHighlight, getHighlightComp } from "@/utils/search";
import Chat from "@/components/Projects/components/Chat";
import ChatState from "@/types/chat/State";
import { Employee, Session, EmployeeAttribute } from "@/types/chat";
import { changeEgovUrl, getAIConfigData } from "@/utils/tools";
import SeacrchMassageHistoryList from "./SearchMessageHistoryList";
import { Avatar } from "@/baseComponents/Avatar";
import { openUserCardModal } from "@/utils/chat/index";
import { analysisLog } from "@/utils/logAnalytics";
import SearchJoyItem from "./SearchJoyItem";
import ImService from "@/server/ImService";
import CHAT_NOTICE from "@/contant/chat";
import { EbookState } from "@/models/ebook";
import { timeSlot } from "./ConditionSearch";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";

let laetId: any = 0;
function DataList({
  onClick,
  searchType,
  openCreateContactModal,
  setCreateModalInputValue,
  allSessionList,
  currentEmployee,
  followUserList,
  customAppList
}: {
  onClick?: (data: ListItemData, index: number, pageSize: number) => void;
  searchType: SearchType;
  openCreateContactModal: Function;
  setCreateModalInputValue: Function;
  allSessionList: Session[];
  currentEmployee: any;
  followUserList: EmployeeAttribute[];
  customAppList: Session[];
}) {
  const {
    onSearchGlobal,
    keyword,
    activeKey,
    t,
    isChange,
    folderIds,
    types,
    scheduleDeadlineTime,
    scheduleColor
  } = React.useContext(SearchGlobalContext);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const [result, setResult] = React.useState<ListItemData[] | any>(null);
  const [hasMore, setHasMore] = React.useState(false);
  const [DeptsData, setDeptsData] = React.useState<DeptInfo>();
  const keywordRef = React.useRef<string>("");
  const folderIdRef = React.useRef<string[] | undefined>([]);
  const typesRef = React.useRef<string[] | undefined>([]);
  const [aiRes, setAiRes] = React.useState<any[]>([]);
  keywordRef.current = keyword;
  folderIdRef.current = folderIds;
  typesRef.current = types;
  const activeKeyRef = React.useRef<SearchType>();
  activeKeyRef.current = activeKey;
  const scheduleDeadlineTimeRef = React.useRef<timeSlot | undefined>(undefined);
  scheduleDeadlineTimeRef.current = scheduleDeadlineTime;
  const scheduleColorRef = React.useRef<string[] | undefined>([]);
  scheduleColorRef.current = scheduleColor;
  // 日程搜索暂时处理日程过多导致搜不到问题，设置日程搜索时pageSize为9999
  const pageSizeRef = React.useRef<number>(activeKey === SearchType.Schedule ? 50 : 20);
  const pageNoRef = React.useRef<number>(1);
  const [loading, setLoading] = useState(true);
  const imService = ImService.getInstance();

  const aiConfigName = useMemo(() => {
    const aiUser = getAIConfigData(appRuntimeEnv, "envConfig.aiConfig.aiUser");
    return aiUser?.name;
  }, [appRuntimeEnv]);

  const handleSearchAi = async (data: any) => {
    let groupId = `aiRobot:dd.notice:focus.bot:${currentEmployee.userId}:${currentEmployee.app}:${currentEmployee.teamId}`;
    const result = data.map((item: any) => {
      return {
        ...item,
        origin: { groupId: groupId, ...item, type: "notice" },
        name: getHighlightComp(
          [
            {
              name: "groupName",
              value: item.name,
              key: keywordRef.current?.toLocaleUpperCase() || "",
              tip: item.userId === CHAT_NOTICE.AI_PIN ? "" : `（来源：${aiConfigName}消息）`
            }
          ],
          "groupName",
          item.name
        )
      };
    });
    return result;
  };

  const getAiSession = async () => {
    // 搜索的Ai类会话放在组的搜索结果前，优先展示
    const searchAi = await imService.searchAI(keywordRef.current);
    if (!searchAi) {
      return;
    }
    const getIndex = (userId: string) => {
      if (userId === CHAT_NOTICE.AI_PIN) {
        return 1;
      }
      return customAppList.findIndex((item: any) => item?.info?.userId === userId);
    };
    const filterRes = searchAi.filter(
      (item: any) =>
        item.userId !== CHAT_NOTICE.ANNOUNCEMENT_PIN &&
        item.userId !== CHAT_NOTICE.SYS_PIN &&
        getIndex(item.userId) > -1
    );
    const dealData = await handleSearchAi(filterRes);
    if (searchType === SearchType.Group) {
      setAiRes(dealData);
    }
  };

  const get = (pageNo: any) => {
    laetId++;
    // eslint-disable-next-line complexity
    return async (theLastId: any) => {
      let params: SearchGlobalParams = {
        keyword: keywordRef.current,
        searchType,
        pageNo,
        pageSize: searchType === SearchType.Contacts ? 50 : pageSizeRef.current
      };
      if (searchType === SearchType.JoySpace) {
        params.bizDocInfo = {
          folderIds: folderIdRef.current,
          types: typesRef.current
        };
      }
      if (searchType === SearchType.Schedule) {
        const scheduleParams: SearchWorkTypes = {};
        if (scheduleColorRef.current) {
          scheduleParams.color = scheduleColorRef.current;
        }
        if (scheduleDeadlineTimeRef.current) {
          scheduleParams.beginTime =
            getStartEndTime(scheduleDeadlineTimeRef.current)?.beginTime || "";
          scheduleParams.endTime = getStartEndTime(scheduleDeadlineTimeRef.current)?.endTime || "";
        }
        params.bizWorkInfo = { ...scheduleParams };
      }
      const res = await onSearchGlobal(params);
      if (laetId === theLastId) {
        if (keywordRef.current) {
          const { apps, contacts, groups, pages, schedules, depts } = res as any;
          setDeptsData(depts);
          let groupList = groups;
          if (groups?.length) {
            groupList = await groupsSort(groups);
          }
          let data = null;
          switch (searchType) {
            case SearchType.Contacts: {
              console.log("filterContactInfo>ls11");
              data = filterContactInfo({
                contacts,
                allSessionList,
                followUserList,
                keyWord: keywordRef.current,
                currentEmployee,
                hasNoResult: false
              });
              break;
            }
            case SearchType.Group: {
              data = filterGroupInfo(groupList);
              break;
            }
            case SearchType.JoySpace: {
              data = filterJoySpaceInfo(pages);
              break;
            }
            case SearchType.Schedule: {
              data = filterScheduleInfo(schedules);
              break;
            }
            case SearchType.App: {
              data = filterAppInfo(apps);
              break;
            }
            case SearchType.Department: {
              data = filterDeptsInfo(depts?.data || []);
              break;
            }
            default:
          }
          if (pageNo === 1) {
            setResult(data || []);
          } else {
            setResult([...(result || []), ...(data || [])]);
          }

          setHasMore(
            searchType === SearchType.Contacts ? false : (data || []).length >= pageSizeRef.current
          );
          setLoading(false);
        }
      }
    };
  };
  const doSearch = async (pageNo: number) => {
    if (activeKeyRef.current !== searchType) {
      return;
    }
    try {
      await get(pageNo)(laetId);
    } catch (e) {
      if (searchType === SearchType.Contacts) {
        console.log("filterContactInfo>ls11");
        const data = filterContactInfo({
          contacts: [],
          allSessionList,
          followUserList,
          keyWord: keywordRef.current,
          currentEmployee,
          hasNoResult: true
        });
        setResult(data);
      } else {
        setResult([]);
      }

      setHasMore(false);
      setLoading(false);
    }
  };

  const doSearchThrottle = React.useRef(throttle(doSearch, 500)).current;

  React.useEffect(() => {
    if (!lodashTrim(keywordRef.current)) {
      setResult(null);
      setLoading(false);
      return;
    }
    if (isChange) {
      return;
    }
    pageNoRef.current = 1;
    if (searchType === SearchType.Group) {
      getAiSession();
    }
    doSearchThrottle(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    keyword,
    activeKey,
    doSearchThrottle,
    searchType,
    isChange,
    folderIds,
    types,
    scheduleDeadlineTime,
    scheduleColor
  ]);

  const getLoadingProp = useCallback((list: ListItemData[] | null) => {
    return {
      delay: 10,
      indicator: loadingIcon,
      spinning: isNull(list),
      wrapperClassName: "loading-wrapper"
    };
  }, []);

  // 添加联系人入口
  const openContact = useCallback(() => {
    openCreateContactModal({ visible: true });
    setCreateModalInputValue(keywordRef.current);
  }, [openCreateContactModal, setCreateModalInputValue]);

  let loadMore = null;
  if (hasMore) {
    loadMore = (
      <LoadMore
        onClick={() => {
          pageNoRef.current = pageNoRef.current + 1;
          doSearch(pageNoRef.current);
        }}
      >
        {t("list.loadMore")}
      </LoadMore>
    );
  } else if (result?.length) {
    const ContactsItem = {
      name: getContactHighlight(keyword),
      // desc: `${t("createButton.searchAddContact")}`,
      id: "1",
      avatar: <Avatar searchIcon={true} styleObj={{ color: "#ffffff" }} />
    };
    loadMore = (
      <>
        {searchType === SearchType.Contacts &&
          config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS] &&
          result?.length < 20 &&
          keyword?.length < 12 &&
          keyword?.length > 1 && (
            <SearchListItem
              data={ContactsItem}
              clstag="pageclick|keycount|xtbg_add_home_1637657110163|53"
              onClick={() => {
                openCreateContactModal({ visible: true });
                setCreateModalInputValue(keywordRef.current);
              }}
              t={t}
            />
          )}
        <LoadMore>
          {searchType === SearchType.JoySpace ? "没有更多了，试试条件筛选" : t("list.noMore")}
        </LoadMore>
      </>
    );
  }

  const GetSearchItem = (item: any, index: number) => {
    const getExtraPart = (item: ListItemData) => {
      if (item.searchKey !== SearchType.Contacts) {
        return false;
      }
      return (
        <div
          style={{
            color: styles.color.primary2,
            marginLeft: 15,
            width: 34,
            height: 30,
            textAlign: "center"
          }}
          onClick={(event: any) => {
            const option = {
              app: item?.origin?.app,
              userId: item?.origin?.userId,
              teamId: item?.origin?.teamId
            };
            analysisLog("xtbg_add_home_1637657110163", "75");
            openUserCardModal((option as unknown) as Employee);
            event.stopPropagation();
          }}
        >
          <img src={changeEgovUrl(userCardIcon)} alt="" style={{ width: 20 }} />
        </div>
      );
    };
    return (
      <div>
        {item.searchKey !== SearchType.MessageHistory &&
          item.searchKey !== SearchType.App &&
          item.searchKey !== SearchType.JoySpace &&
          item.searchKey !== SearchType.Schedule && (
            <SearchListItem
              // style={{
              //     paddingLeft: 24,
              // }}
              data={item}
              onClick={() => {
                if (onClick) {
                  onClick(
                    item,
                    index,
                    searchType === SearchType.Contacts ? 50 : pageSizeRef.current
                  );
                }
              }}
              t={t}
              extra={getExtraPart(item)}
            />
          )}
        {/* 显示文档记录 */}
        {item.searchKey === SearchType.JoySpace && (
          <SearchJoyItem
            t={t}
            data={item}
            onClick={() => {
              if (onClick) {
                onClick(item, index, searchType === SearchType.Contacts ? 50 : pageSizeRef.current);
              }
            }}
          />
        )}
        {/* 显示聊天记录 */}
        {item.searchKey === SearchType.MessageHistory && (
          <SeacrchMassageHistoryList t={t} activeKey={activeKey} keyWord={keywordRef.current} />
        )}
        {/* 应用展示 */}
        {item.searchKey === SearchType.App && (
          <SearchAppItem
            // style={{
            //     paddingLeft: 24,
            // }}
            data={item}
            onClick={() => {
              if (onClick) {
                onClick(item, index, searchType === SearchType.Contacts ? 50 : pageSizeRef.current);
              }
            }}
            t={t}
          />
        )}
        {/* 日程展示 */}
        {item.searchKey === SearchType.Schedule && (
          <SearchScheduleItem
            // style={{
            //     paddingLeft: 24,
            // }}
            data={item}
            onClick={() => {
              if (onClick) {
                onClick(item, index, searchType === SearchType.Contacts ? 50 : pageSizeRef.current);
              }
            }}
            t={t}
          />
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: "200px"
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <div>
      {([...aiRes, ...result] || []).length === 0 ? (
        DeptsData && DeptsData?.code === "-1" ? (
          <p style={{ padding: "12px 16px" }}>{DeptsData?.message}</p>
        ) : (
          <div>
            {searchType === "1" ? (
              <div
                style={{
                  margin: "40px 20px 0",
                  color: "#A3A3A3",
                  fontSize: "14px"
                }}
              >
                <p
                  style={{
                    color: "#000000",
                    fontSize: "16px",
                    marginBottom: "23px",
                    textAlign: "center"
                  }}
                >
                  {getContactHighlight(keyword)}
                </p>
                <p style={{ marginLeft: "70px" }}>1、请检查关键词是否输入正确</p>
                <p style={{ marginLeft: "70px" }}>2、该联系人可能不在您的通讯录中</p>
              </div>
            ) : (
              <Empty image={noContent} description={t("search.nodata")} />
            )}
            {/* <Empty image={noContent} description={t('search.nodata')} /> */}
            {searchType === "1" && config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS] && (
              <div style={{ textAlign: "center", marginTop: 30 }}>
                <Button
                  style={{ border: " 1px solid #1890ff", color: "#1890ff" }}
                  onClick={openContact}
                  clstag="pageclick|keycount|xtbg_add_home_1637657110163|52"
                >
                  {t("createButton.searchAddContact")}
                </Button>
              </div>
            )}
          </div>
        )
      ) : (
        <List
          loading={getLoadingProp([...aiRes, result])}
          dataSource={[...aiRes, ...result] || []}
          loadMore={loadMore}
          renderItem={(item: any, index: number) => GetSearchItem(item, index)}
        />
      )}
    </div>
  );
}
function mapStateToProps({ chat, ebook }: { chat: ChatState; ebook: EbookState }) {
  return {
    allSessionList: chat.allSessionList,
    followUserList: ebook.followUserList,
    currentEmployee: chat.currentEmployee,
    customAppList: chat.customAppList
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    setCreateModalInputValue(data: any) {
      dispatch({ type: "ebook/setCreateModalInputValue", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DataList);
